export default "__VITE_ASSET__CCZQxsCy__"